var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconamoonProfileFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81055 7.64014C8.81055 6.57927 9.23197 5.56185 9.98212 4.81171C10.7323 4.06156 11.7497 3.64014 12.8105 3.64014C13.8714 3.64014 14.8888 4.06156 15.639 4.81171C16.3891 5.56185 16.8105 6.57927 16.8105 7.64014C16.8105 8.701 16.3891 9.71842 15.639 10.4686C14.8888 11.2187 13.8714 11.6401 12.8105 11.6401C11.7497 11.6401 10.7323 11.2187 9.98212 10.4686C9.23197 9.71842 8.81055 8.701 8.81055 7.64014ZM8.81055 13.6401C7.48446 13.6401 6.21269 14.1669 5.27501 15.1046C4.33733 16.0423 3.81055 17.3141 3.81055 18.6401C3.81055 19.4358 4.12662 20.1988 4.68923 20.7615C5.25184 21.3241 6.0149 21.6401 6.81055 21.6401H18.8105C19.6062 21.6401 20.3693 21.3241 20.9319 20.7615C21.4945 20.1988 21.8105 19.4358 21.8105 18.6401C21.8105 17.3141 21.2838 16.0423 20.3461 15.1046C19.4084 14.1669 18.1366 13.6401 16.8105 13.6401H8.81055Z",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconamoonProfileFill);
export default __webpack_public_path__ + "static/media/iconamoon_profile-fill.a43d3a70c5d5d307dd592d352abfd1bf.svg";
export { ForwardRef as ReactComponent };